import React from 'react';
import { InformationChip } from '@europrocurement/flexy-components';
import { Typography } from '@mui/material';
import { useStatusStyle } from '@europrocurement/l2d-modules';

export type DossierArticleProcessStatusProps = {
    statusLabel: string;
    statusFlag: number;
    onClick?: () => void;
};

const DossierArticleProcessStatus: React.FunctionComponent<DossierArticleProcessStatusProps> =
    function (props) {
        const { statusLabel, statusFlag, onClick } = props;
        const { getValidatorStatusStyle } = useStatusStyle();
        const { iconProp, sxStatus } = getValidatorStatusStyle(statusFlag);

        const handleClick = () => {
            if (onClick) {
                onClick();
            }
        };

        return (
            <InformationChip
                sx={{
                    ...sxStatus,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: onClick !== undefined ? 'pointer' : 'default',
                }}
                sxIcon={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                icon={iconProp}
                label={
                    <Typography
                        onClick={handleClick}
                        variant="l2dbodys"
                    >
                        {statusLabel}
                    </Typography>
                }
            />
        );
    };

export default DossierArticleProcessStatus;
